import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>นโยบายความเป็นส่วนตัว</h2>
            <p><strong>นโยบายความเป็นส่วนตัวของ Dreamehome</strong></p>
            <p><strong>บทนำ</strong></p>
            <p>"Dreamehome" เป็นแพลตฟอร์ม (หรือบริการ) ที่ให้บริการควบคุมและจัดการอุปกรณ์ฮาร์ดแวร์อัจฉริยะ ดำเนินโดยบริษัท
                ดรีมมี่
                อินโนเวชั่น เทคโนโลยี (ซูโจว) จำกัด และบริษัทในเครือ (ต่อไปนี้จะเรียกว่า "เรา" หรือ "ดรีมมี่")
                เราเข้าใจถึงความสำคัญของข้อมูลส่วนบุคคล และจะพยายามรักษาความปลอดภัยของข้อมูลส่วนบุคคลของคุณอย่างดีที่สุด
                เราจะใช้มาตรการรักษาความปลอดภัยที่เหมาะสมในการคุ้มครองข้อมูลส่วนบุคคลของคุณ
                ตามมาตรฐานการรักษาความปลอดภัยที่เป็นที่ยอมรับในวงการ</p>
            <p>ดังนั้น โปรดอ่านและทำความเข้าใจ "นโยบายความเป็นส่วนตัวของ Dreamehome" อย่างละเอียดก่อนที่จะใช้ผลิตภัณฑ์
                (หรือบริการ) ของเรา</p>
            <p>หากคุณเป็นผู้เยาว์
                โปรดใช้แอปพลิเคชันนี้และยอมรับข้อกำหนดในการให้บริการที่เกี่ยวข้องหลังจากได้รับความยินยอมจากผู้ปกครอง</p>
            <p>เราได้พิจารณาถึงความต้องการของคุณอย่างละเอียดถี่ถ้วนในระหว่างการจัดทำนโยบายความเป็นส่วนตัวนี้
                การที่ให้คุณได้เข้าใจถึงวิธีการรวบรวมและการใช้ข้อมูลส่วนบุคคลของเราอย่างละเอียด
                และให้คุณสามารถควบคุมข้อมูลส่วนบุคคลที่ให้ไว้กับเราได้นั้น มีความสำคัญอย่างยิ่ง
                นโยบายความเป็นส่วนตัวนี้ได้กำหนดวิธีการที่เรารวบรวม ใช้งาน เปิดเผย ประมวลผล
                และจัดเก็บข้อมูลที่คุณให้ไว้กับเราเมื่อใช้ App ของเรา
                เราจะปฏิบัติตามนโยบายความเป็นส่วนตัวนี้อย่างเคร่งครัดในระหว่างการใช้ข้อมูลเหล่านี้</p>
            <p>นโยบายความเป็นส่วนตัวนี้จะช่วยให้คุณได้เข้าใจถึงรายละเอียดดังต่อไปนี้:</p>
            <p>๑. ข้อมูลอะไรบ้างที่เรารวบรวมและวิธีการใช้ข้อมูล</p>
            <p>๒. วิธีการใช้ Cookie และเทคโนโลยีที่คล้ายคลึงกัน</p>
            <p>๓. วิธีการจ้างประมวลผล แบ่งปัน ถ่ายโอน และเปิดเผยข้อมูลส่วนบุคคลของคุณ</p>
            <p>๔. วิธีการจัดเก็บและคุ้มครองข้อมูลส่วนบุคคลของคุณ</p>
            <p>๕. สิทธิของคุณ</p>
            <p>๖. การถ่ายโอนข้อมูลข้ามพรมแดน</p>
            <p>๗. ติดต่อเรา</p>
            <p>๘. วิธีการอัปเดตของนโยบายความเป็นส่วนตัวนี้</p>
            <p>ตารางแนบท้ายที่ 1 : รายละเอียดของ SDK บุคคลที่สาม</p>
            <p>สุดท้าย วัตถุประสงค์ของเราคือ มอบประสบการณ์การใช้งานที่ดีที่สุดแก่คุณ หากคุณมีข้อสงสัยใด ๆ
                เกี่ยวกับนโยบายความเป็นส่วนตัวนี้ เรามีหน่วยงานและเจ้าหน้าที่ทำงานเกี่ยวกับความเป็นส่วนตัวโดยเฉพาะ
                คุณสามารถติดต่อไปตามข้อมูลติดต่อในบทที่ ๗ ของนโยบายความเป็นส่วนตัวนี้ได้
                เราจะให้คำตอบตามเวลาที่กำหนดโดยนโยบายและกฎหมายของแต่ละประเทศ หากคุณไม่พอใจกับคำตอบของเรา
                โดยเฉพาะในกรณีที่คุณคิดว่าการประมวลผลข้อมูลส่วนบุคคลของเราละเมิดสิทธิตามกฎหมายของคุณ
                คุณยังสามารถแก้ไขผ่านช่องทางภายนอก เช่น การยื่นฟ้องต่อศาลที่มีอำนาจ
                และการร้องเรียนไปยังหน่วยงานกำกับดูแลของรัฐบาล
                เป็นต้น</p>
            <p><strong>๑. ข้อมูลอะไรบ้างที่เรารวบรวมและวิธีการใช้ข้อมูล</strong></p>
            <p>ข้อมูลส่วนบุคคลหมายถึงข้อมูลต่าง ๆ ที่ถูกบันทึกทางอิเล็กทรอนิกส์หรือในรูปแบบอื่น ซึ่งสามารถระบุตัวบุคคลได้โดยตรง
                หรือระบุตัวบุคคลได้หลังจากได้เชื่อมโยงกับข้อมูลอื่น ๆ</p>
            <p>ข้อมูลส่วนบุคคลที่ละเอียดอ่อนหมายถึงข้อมูลส่วนบุคคลที่ตราบใดเกิดการรั่วไหล การให้หรือการใช้งานอย่างผิดกฎหมาย
                อาจเป็นอันตรายต่อความปลอดภัยส่วนบุคคลและทรัพย์สิน ทำให้ชื่อเสียง สุขภาพกายและสุขภาพจิตได้รับความเสียหาย
                หรือถูกเลือกปฏิบัติได้อย่างง่ายดาย รวมถึงแต่ไม่จำกัดเพียงหมายเลขประจำตัวประชาชน ข้อมูลชีวมาตร หมายเลขบัญชีธนาคาร
                ข้อมูลทรัพย์สิน ข้อมูลการเดินทาง ข้อมูลการซื้อขาย และข้อมูลส่วนบุคคลของเด็กอายุต่ำกว่า 14 ปี (รวม 14 ปี) เป็นต้น
            </p>
            <p>วัตถุประสงค์หลักของเราในการรวบรวมข้อมูลส่วนบุคคลคือ เพื่อให้ผลิตภัณฑ์และ/หรือบริการแก่คุณ
                และรับประกันว่าเราจะปฏิบัติตามกฎหมาย ระเบียบข้อบังคับ และเอกสารข้อกำหนดอื่น ๆ ที่เกี่ยวข้อง
                คุณมีสิทธิที่จะเลือกว่าจะให้หรือไม่ให้ข้อมูลเหล่านี้ แต่ในกรณีส่วนใหญ่ หากคุณไม่ให้ข้อมูลมา
                เราอาจไม่สามารถให้บริการที่เกี่ยวข้องแก่คุณได้ และไม่สามารถให้การตอบสนองกับปัญหาที่คุณพบ</p>
            <p><strong>(๑) การรวบรวมและประมวลผลข้อมูลส่วนบุคคลของคุณเพื่อบริการพื้นฐานของ Dreamehome</strong></p>
            <p><strong>(1) การเชื่อมต่อแอปพลิเคชัน Dreamehome กับอุปกรณ์ฮาร์ดแวร์อัจฉริยะ และการจัดการอุปกรณ์ผ่านแอป</strong>
            </p>
            <p>เพื่อให้บริการ Dreamehome แก่คุณ ช่วยให้คุณสามารถเชื่อมต่อและจัดการอุปกรณ์ฮาร์ดแวร์อัจฉริยะอย่างปลอดภัย
                เราอาจรวบรวมข้อมูล Wi-Fi ข้อมูลตำแหน่งที่อยู่ ข้อมูลบัญชีที่ลงชื่อเข้าใช้ ข้อมูลที่เกี่ยวข้องกับโทรศัพท์มือถือ
                ข้อมูลที่เกี่ยวข้องกับอุปกรณ์ฮาร์ดแวร์อัจฉริยะ
                และข้อมูลการเชื่อมต่อระหว่างบัญชีดรีมมี่กับอุปกรณ์ฮาร์ดแวร์อัจฉริยะของคุณ
                ข้อมูลเหล่านี้จะถูกนำไปใช้ในฟังก์ชั่นต่าง
                ๆ เพื่อให้บริการแก่คุณ เช่น การเชื่อมต่ออุปกรณ์ฮาร์ดแวร์อัจฉริยะแบบด่วน การเชื่อมต่ออุปกรณ์ฮาร์ดแวร์อัจฉริยะ
                การค้นหาอุปกรณ์ในบริเวณใกล้เคียง และการจัดการอุปกรณ์ เป็นต้น รายละเอียดของข้อมูลข้างต้นดังต่อไปนี้:</p>
            <p>ข้อมูลบัญชีที่ลงชื่อเข้าใช้: ชื่อผู้ใช้ รหัสผ่าน ชื่อเล่น รูปโปรไฟล์ของบัญชีดรีมมี่ของคุณ และอีเมล
                หมายเลขโทรศัพท์มือถือของคุณ ซึ่ง<strong>ชื่อผู้ใช้ รหัสผ่าน หมายเลขโทรศัพท์มือถือ
                    และอีเมลเป็นข้อมูลส่วนบุคคลที่ละเอียดอ่อน</strong>
                การรวบรวมข้อมูลประเภทนี้มีวัตถุประสงค์เพื่อเข้าสู่ระบบเซิร์ฟเวอร์บัญชี ยืนยันตัวตนของผู้ใช้
                และรับการอนุญาตให้บัญชี
                Dreamehome สามารถเข้าถึงเซิร์ฟเวอร์ได้ ข้อมูลยืนยันตัวตนที่คุณให้มา เช่น ชื่อผู้ใช้ และรหัสผ่านของบัญชี
                จะถูกเข้ารหัสและส่งไปยังเซิร์ฟเวอร์ของบัญชีดรีมมี่ เพื่อตรวจสอบการเข้าสู่ระบบ</p>
            <p>ข้อมูลเกี่ยวกับโทรศัพท์มือถือ: หมายเลขประจำเครื่องของอุปกรณ์ฮาร์ดแวร์ (IMEI/OAID ที่อยู่ Mac
                และรหัสเฉพาะเครื่องสำหรับอุปกรณ์ Android) รุ่นของโทรศัพท์มือถือ ข้อมูลเวอร์ชั่นของระบบ ภาษาของระบบ
                ประเทศหรือภูมิภาคที่ตั้งค่าไว้ในโทรศัพท์มือถือ ขนาดและความละเอียดของหน้าจอโทรศัพท์มือถือ CPU และข้อมูลอื่น ๆ
                ที่เกี่ยวข้องกับอุปกรณ์แสดงผล การรวบรวมข้อมูลประเภทนี้ มีวัตถุประสงค์เพื่อให้แอปพลิเคชัน Dreamehome
                สามารถเชื่อมต่อกับอุปกรณ์ฮาร์ดแวร์อัจฉริยะได้</p>
            <p>ข้อมูลของอุปกรณ์ฮาร์ดแวร์อัจฉริยะ: ชื่อ รุ่น เวอร์ชั่น ผู้ผลิต หมายเลขประจำตัวเครื่อง ที่อยู่ MAC เลขที่อยู่ไอพี
                สถานะการทำงานของอุปกรณ์ คุณสมบัติที่กำหนดเอง ค่าพารามิเตอร์ที่ตั้งไว้ เหตุการณ์ระหว่างการทำงาน
                และบันทึกการควบคุมและการใช้งานของอุปกรณ์ฮาร์ดแวร์อัจฉริยะ
                การรวบรวมข้อมูลประเภทนี้มีวัตถุประสงค์เพื่อเชื่อมต่อกับอุปกรณ์ฮาร์ดแวร์อัจฉริยะ ควบคุมและจัดการอุปกรณ์
                ตั้งค่าคุณสมบัติและค่าพารามิเตอร์อุปกรณ์ เรียกดูสถานะการทำงานและประวัติของอุปกรณ์</p>
            <p><strong>(2) การอัปเกรดแอปพลิเคชัน Dreamehome และอุปกรณ์ฮาร์ดแวร์อัจฉริยะ</strong></p>
            <p>เพื่อให้คุณได้รับบริการล่าสุดของ Dreamehome อย่างต่อเนื่อง เราอาจใช้ข้อมูลเวอร์ชั่นของแอปพลิเคชัน Dreamehome
                และรุ่นของโทรศัพท์มือถือของคุณ เพื่อให้บริการการอัปเกรดแอปพลิเคชัน Dreamehome แก่คุณ ในเวลาเดียวกัน
                เราอาจรวบรวมข้อมูลรายชื่ออุปกรณ์ฮาร์ดแวร์อัจฉริยะที่คุณได้เชื่อมต่อไว้และหมายเลขเวอร์ชั่นของอุปกรณ์
                เพื่ออัปเกรดอุปกรณ์ฮาร์ดแวร์อัจฉริยะของคุณ ให้คุณได้รับบริการเวอร์ชั่นใหม่ล่าสุด (รวมถึงเวอร์ชั่นเฟริ์มแวร์)
                Dreamehome รับผิดชอบต่อช่องทางการอัปเกรดอุปกรณ์ฮาร์ดแวร์อัจฉริยะเท่านั้น
                เวอร์ชั่นเฟิร์มแวร์ของอุปกรณ์ฮาร์ดแวร์อัจฉริยะต้องมาจากผู้ผลิตอุปกรณ์ฮาร์ดแวร์อัจฉริยะ
                และผู้ผลิตต้องรับผิดชอบต่อคุณภาพของเวอร์ชั่นและผลการอัปเกรด</p>
            <p>หากคุณไม่ให้ข้อมูลประเภทนี้มา จะไม่สามารถอัปเกรดแอปพลิเคชัน Dreamehome
                และเฟิร์มแวร์ของอุปกรณ์ฮาร์ดแวร์อัจฉริยะให้เป็นเวอร์ชั่นล่าสุดได้</p>
            <p><strong>(3) การให้ข้อเสนอแนะออนไลน์</strong></p>
            <p>เพื่อช่วยให้คุณแก้ไขปัญหาที่อาจเกิดขึ้นกับแอปพลิเคชัน Dreamehome
                และอุปกรณ์ฮาร์ดแวร์อัจฉริยะได้อย่างมีประสิทธิภาพมากขึ้น เรามีช่องทางรับข้อเสนอแนะออนไลน์สำหรับคุณ
                เพื่อให้สามารถรับข้อเสนอแนะจากคุณได้ เราต้องการรวบรวมข้อมูลต่อไปนี้จากคุณ: ข้อมูลบันทึกของแอปพลิเคชัน Dreamehome
                และอุปกรณ์ วิธีการติดต่อของคุณ รายละเอียดของปัญหาที่คุณเสนอแนะ ภาพถ่ายและวิดีโอของปัญหา
                ซึ่งข้อมูลบันทึกของแอปพลิเคชันและอุปกรณ์ รวมถึงสถานะอุปกรณ์ ข้อมูลที่รับรู้โดยเซ็นเซอร์ บันทึกการทำงานของอุปกรณ์
                และหมายเลขประจำตัวเครื่อง เป็นต้น การรวบรวมข้อมูลประเภทนี้มีวัตถุประสงค์เพื่อวิเคราะห์และหาสาเหตุของปัญหา
                การรวบรวมข้อมูลติดต่อของคุณมีวัตถุประสงค์เพื่อติดตามผลการแก้ไข ว่าปัญหาได้รับการแก้ไขอย่างสมบูรณ์หรือไม่
                หรือติดต่อคุณเพื่อขอข้อมูลเพิ่มเติมที่จำเป็นจากคุณ</p>
            <p>เราจะใช้ข้อมูลส่วนบุคคลของคุณตามวิธีการต่อไปนี้: ใช้ในการหาสาเหตุและแก้ไขปัญหาที่ระบุไว้ในข้อเสนอแนะเท่านั้น
                ไม่ใช้ในการแสดงข้อมูลส่วนบุคคล และไม่ใช้ในการส่งโฆษณาเพื่อการค้า หากคุณไม่ให้ข้อมูลประเภทนี้มา
                จะไม่สามารถหาสาเหตุและแก้ไขปัญหาที่ระบุไว้ในข้อเสนอแนะของคุณได้อย่างมีประสิทธิภาพ</p>
            <p><strong>(๒) การรวบรวมและประมวลผลข้อมูลส่วนบุคคลของคุณ เพื่อให้บริการอื่น ๆ ที่นอกเหนือจากบริการพื้นฐานของ
                Dreamehome</strong></p>
            <p>นอกเหนือจากบริการพื้นฐานของ Dreamehome จะใช้ข้อมูลส่วนบุคคลของคุณแล้ว
                ฟังก์ชั่นเสริมของเราอาจรวบรวมและใช้ข้อมูลส่วนบุคคลของคุณเช่นกัน หากคุณไม่ให้ข้อมูลส่วนบุคคลเหล่านี้มา
                คุณยังคงสามารถใช้บริการพื้นฐานของ Dreamehome ได้ แต่อาจไม่สามารถใช้ฟังก์ชั่นเสริมที่อำนวยความสะดวกแก่คุณได้
                ซึ่งฟังก์ชั่นเสริมรวมถึง:</p>
            <p><strong>แผนการปรับปรุงประสบการณ์ผู้ใช้:</strong></p>
            <p>เพื่อปรับปรุงประสบการณ์ผู้ใช้ เราต้องการรวบรวมข้อมูลต่อไปนี้จากคุณ: ข้อมูลบันทึกของ Dreamehome
                ซึ่งรวมถึงบันทึกของกระบวนการสำคัญ บันทึกเหตุการณ์ บันทึกข้อผิดพลาด เหตุการณ์ระหว่างการทำงาน
                สภาพการใช้งานของหน้าอินเตอร์เฟสต่าง ๆ ใน App ที่ถูกเข้ารหัสอย่างเรียบร้อย
                ข้อมูลที่ละเอียดอ่อนของคุณจะไม่ถูกบันทึกในนี้</p>
            <p>เราจะใช้ข้อมูลส่วนบุคคลของคุณตามวิธีการต่อไปนี้: รวบรวมข้อมูลข้างต้นและอัปโหลดไปยังเซิร์ฟเวอร์โดยอัตโนมัติ
                วิเคราะห์ข้อมูลที่บันทึก สถานะการทำงานของอุปกรณ์ และสภาพการใช้ App</p>
            <p>หากคุณไม่ให้ข้อมูลเหล่านี้มา Dreamehome จะไม่สามารถปรับปรุงประสบการณ์การใช้งานของคุณอย่างรวดเร็วได้
                แต่ไม่ส่งผลกระทบต่อการใช้ฟังก์ชั่นพื้นฐานของบริการนี้</p>
            <p><strong>(๓) การได้รับข้อมูลส่วนบุคคลของคุณจากบุคคลที่สาม</strong></p>
            <p>เราอาจได้รับข้อมูลส่วนบุคคลของคุณจากบุคคลที่สามในกรณีที่กฎหมายอนุญาต เช่น:</p>
            <p>1. หลังจากได้รับความยินยอมจากคุณแล้ว เราจะร่วมมือกับผู้ให้บริการบุคคลที่สาม
                เพื่อจัดการอุปกรณ์ฮาร์ดแวร์อัจฉริยะของบุคคลที่สาม
                ซึ่งเกี่ยวข้องกับการรับข้อมูลส่วนบุคคลของคุณจากผู้ให้บริการบุคคลที่สาม ในระหว่างการจัดการอุปกรณ์บุคคลที่สาม
                เราจะได้รับข้อมูลส่วนบุคคลต่อไปนี้จากบัญชีบุคคลที่สามที่คุณได้ผูกไว้:</p>
            <p>ข้อมูลของบัญชีบุคคลที่สาม รวมถึงชื่อเล่นและรูปโปรไฟล์ของคุณ เพื่อแสดงในแอปพลเคชัน Dreamehome</p>
            <p>ข้อมูลอุปกรณ์และเครือข่าย รวมถึงหมายเลขประจำตัวเครื่อง ที่อยู่ MAC หมายเลขซีเรียลของอุปกรณ์
                เพื่อระบุอุปกรณ์ที่ใช้อยู่ในปัจจุบัน และควบคุมความปลอดภัยของอุปกรณ์</p>
            <p>หากการประมวลผลข้อมูลส่วนบุคคลระหว่างการดำเนินการของเรา
                เกินขอบเขตที่คุณได้อนุญาตไว้เมื่อให้ข้อมูลส่วนบุคคลแก่ผู้ให้บริการบุคคลที่สาม เราจะขอความยินยอมจากคุณอย่างชัดเจน
                ก่อนที่จะประมวลผลข้อมูลส่วนบุคคลของคุณ นอกจากนี้แล้ว
                เราจะปฏิบัติตามกฎหมายและระเบียบข้อบังคับที่เกี่ยวข้องอย่างเคร่งครัด
                และกำหนดให้ผู้ให้บริการบุคคลที่สามรับประกันความถูกต้องตามกฎหมายของข้อมูลที่ให้มา</p>
            <p><strong>(๔) ข้อมูลอื่น ๆ ที่ไม่ใช่ข้อมูลส่วนบุคคล</strong></p>
            <p>เรายังอาจรวบรวมข้อมูลอื่น ๆ ที่ไม่สามารถระบุตัวบุคคลได้ (ซึ่งเป็นข้อมูลที่ไม่ใช่ข้อมูลส่วนบุคคล) เช่น
                ข้อมูลสถิติที่เกิดขึ้นในระหว่างที่คุณใช้บริการใดบริการหนึ่งอยู่ ซึ่งเป็นพฤติกรรมการใช้งานของผู้ใช้
                (รวมถึงการคลิก
                การเปลี่ยนหน้าเพจ เวลาในการเรียกดู) การรวบรวมข้อมูลประเภทนี้มีวัตถุประสงค์เพื่อปรับปรุงบริการของคุณ
                ประเภทและปริมาณข้อมูลที่รวบรวมขึ้นอยู่กับวิธีการที่คุณใช้ผลิตภัณฑ์และ/หรือบริการของเรา
                เราจะรวบรวมข้อมูลประเภทนี้ไว้
                เพื่อช่วยให้เราให้ข้อมูลที่เป็นประโยชน์มากขึ้นแก่ลูกค้าของเรา ทำความเข้าใจว่าลูกค้าสนใจส่วนใดของเว็บไซต์
                ผลิตภัณฑ์
                และบริการของเรามากที่สุด เพื่อปรับปรุงหน้าอินเตอร์เฟสการให้บริการของเราให้มีประสิทธิภาพมากขึ้น
                สำหรับนโยบายความเป็นส่วนตัวนี้ ข้อมูลสถิติเหล่านี้ไม่ใช่ข้อมูลส่วนบุคคล
                หากเราใช้ข้อมูลที่ไม่ใช่ข้อมูลส่วนบุคคลผสมกับข้อมูลส่วนบุคคล ในระหว่างการใช้ร่วมกัน
                ข้อมูลประเภทนี้จะถือว่าเป็นข้อมูลส่วนบุคคลเช่นกัน</p>
            <p><strong>๒. วิธีการใช้ Cookie และเทคโนโลยีที่คล้ายคลึงกัน</strong></p>
            <p>เพื่อให้ Dreamehome ทำงานตามปกติ เราจะเก็บไฟล์ข้อมูลขนาดเล็กที่ชื่อ Cookie ไว้ในอุปกรณ์ของคุณ Cookie
                มักจะรวมถึงชื่อ ชื่อไซต์ ตัวเลข และอักขระบางตัว ด้วยความช่วยเหลือของ Cookie Dreamehome
                สามารถจัดเก็บข้อมูลบัญชีเว็บไซต์และค่าการทำงานของคุณได้</p>
            <p>เราจะไม่ใช้ Cookie เพื่อวัตถุประสงค์อื่นใดนอกเหนือจากที่ระบุไว้ในนโยบายความเป็นส่วนตัวนี้ คุณสามารถจัดการหรือลบ
                Cookie ตามความต้องการของคุณได้ แต่หากคุณทำเช่นนี้ อาจส่งผลกระทบต่อความปลอดภัยในการเข้าถึง Dreamehome ในบางกรณี
                และอาจต้องแก้ไขการตั้งค่าผู้ใช้ด้วยตนเองในทุกครั้งที่เข้าใช้ Dreamehome</p>
            <p><strong>๓. วิธีการจ้างประมวลผล แบ่งปัน ถ่ายโอน และเปิดเผยข้อมูลส่วนบุคคลของคุณ</strong></p>
            <p><strong>(๑) การจ้างประมวลผล</strong></p>
            <p>โดยปกติแล้ว ดรีมมี่อาจมอบหมายให้บริษัทอื่นเป็นตัวแทนของเราในการประมวลผลข้อมูลส่วนบุคคลของคุณ เช่น บริษัทที่ติดต่อ
                ส่งอีเมล หรือให้การสนับสนุนด้านเทคนิคแก่คุณแทนเรา
                บริษัทเหล่านี้สามารถใช้ข้อมูลส่วนบุคคลของคุณเพื่อให้บริการแก่คุณในนามของเราเท่านั้น</p>
            <p>เราจะทำข้อตกลงรักษาความลับหรือข้อกำหนดการประมวลผลข้อมูลส่วนบุคคลที่เข้มงวดกับผู้รับมอบหมาย
                ให้ผู้รับมอบหมายปฏิบัติตามนโยบายความเป็นส่วนตัวนี้
                ใช้มาตรการรักษาความลับและความปลอดภัยที่เหมาะสมกับการประมวลผลข้อมูลส่วนบุคคล</p>
            <p><strong>(๒) การแบ่งปัน</strong></p>
            <p>โดยปกติแล้ว เราจะไม่แบ่งปันข้อมูลส่วนบุคคลของคุณกับภายนอก ยกเว้นในกรณีต่อไปนี้:</p>
            <p>1. หลังจากได้รับความยินยอมจากคุณมาอย่างชัดเจน เราจะแบ่งปันข้อมูลกับบุคคลที่สามที่คุณกำหนด
                โดยไม่เกินขอบเขตที่คุณได้อนุญาตไว้
                รวมถึงการแบ่งปันข้อมูลและค่าการทำงานของผลิตภัณฑ์อัจฉริยะที่ใช้ภายในบ้านคุณแก่ญาติและเพื่อนของคุณตามความต้องการของคุณ
                เพื่อช่วยให้ญาติและเพื่อนของคุณใช้ซอฟต์แวร์และบริการผ่านอุปกรณ์ปลายทางของพวกเขาอย่างรวดเร็ว</p>
            <p>2. บริการบางส่วนของ Dreamehome มาจากผู้ให้บริการบุคคลที่สาม ดังนั้น
                เราต้องให้ข้อมูลส่วนบุคคลบางส่วนแก่ผู้ให้บริการบุคคลที่สาม เช่น เว็บโฮสติ้ง การวิเคราะห์ข้อมูล
                การชำระและการจัดการบัตรเครดิต การให้บริการโครงสร้างพื้นฐาน บริการ IT บริการสนับสนุนลูกค้า บริการส่งอีเมล
                และบริการอื่น ๆ ที่คล้ายคลึงกัน เพื่อให้พวกเขาสามารถให้บริการแก่เราได้</p>
            <p>3. เปิดเผยข้อมูลส่วนบุคคลของคุณต่อลูกค้าและคู่ค้าอื่น ๆ ที่เป็นผู้ผลิตอุปกรณ์ฮารด์แวร์อัจฉริยะของคุณ
                และ/หรือผู้ให้บริการเครือข่ายและระบบเพื่อให้คุณเข้าถึงและใช้เว็บไซต์กับบริการของเรา โดยตรงหรือโดยอ้อม</p>
            <p>4. เปิดเผยข้อมูลส่วนบุคคลของคุณต่อบริษัทในเครือหรือบุคคลที่สาม เมื่อมีการปรับโครงสร้าง การควบรวมกิจการ
                การขายกิจการ
                การร่วมทุน การโอนสิทธิ์การใช้ การโอนกรรมสิทธิ์ หรือการจำหน่ายอื่น ๆ กับธุรกิจ ทรัพย์สิน
                หรือหุ้นทั้งหมดหรือบางส่วนของเรา (รวมถึงแต่ไม่จำกัดเพียงกรณีการล้มละลาย หรือการดำเนินการที่คล้ายคลึงกัน)
                คุณจะได้รับการแจ้งเตือนที่ชัดเจนเกี่ยวกับการเปลี่ยนแปลงสิทธิความเป็นเจ้าของ
                ความไม่เข้ากันของวิธีใหม่ในการใช้ข้อมูลส่วนบุคคล และทางเลือกที่เกี่ยวกับข้อมูลส่วนบุคคล
                ผ่านอีเมลและ/หรือเว็บไซต์ของเราในกรณีดังกล่าว</p>
            <p>5. เมื่อเราเห็นว่ามีความจำเป็นหรือมีความเหมาะสม: (a) ปฏิบัติตามกฎหมายและระเบียบข้อบังคับที่ใช้บังคับ (b)
                ปฏิบัติตามขั้นตอนทางกฎหมาย (c) ตอบสนองความต้องการของหน่วยงานสาธารณะและรัฐบาล
                ซึ่งรวมถึงหน่วยงานสาธารณะและรัฐบาลที่อยู่นอกเหนือจากประเทศ/ภูมิภาคที่คุณอาศัยอยู่ (d)
                ปฏิบัติตามข้อกำหนดและเงื่อนไขของเรา (e) ปกป้องการปฏิบัติงาน ธุรกิจ และระบบของเรา (f) ปกป้องสิทธิ ความเป็นส่วนตัว
                ความปลอดภัย หรือทรัพย์สินของเรา และ/หรือผู้ใช้รายอื่น ซึ่งรวมคุณด้วย และ (g) ค้นหามาตรการแก้ไขที่ใช้ได้
                หรือจำกัดความเสียหายที่เราอาจต้องชดเชย</p>
            <p>6. เปิดเผยข้อมูลส่วนบุคคลของคุณต่อบริษัทย่อยหรือบริษัทในเครือ เพื่อดำเนินกิจกรรมทางธุรกิจตามแผนการ</p>
            <p>7. เราจะแบ่งปันข้อมูลที่จำเป็นกับบุคคลที่สามผ่านส่วนต่อประสานโปรแกรมประยุกต์ (API) และชุดเครื่องมือพัฒนาซอฟต์แวร์
                (SDK) SDK เวอร์ชั่นต่าง ๆ ของบุคคลที่สามจะแตกต่างกัน โดยปกติมีประเภทการลงชื่อเข้าใช้ด้วยบัญชีของบุคคลที่สาม
                ประเภทการแบ่งปัน ประเภทการชำระเงินผ่านบุคคลที่สาม ประเภทการส่งข้อมูลโดยผู้ผลิต และประเภทสถิติ เป็นต้น
                เราจะดำเนินการตรวจสอบความปลอดภัยอย่างเข้มงวดกับบุคคลที่สาม และมีข้อตกลงเกี่ยวกับมาตรการคุ้มครองข้อมูล ภาคผนวก 1
                เป็นรายละเอียดของ SDK บุคคลที่สามที่เราอนุญาตให้ใช้ได้ โปรดอ่านอย่างละเอียด
                นโยบายความเป็นส่วนตัวของเราไม่ใช้บังคับแก่ผลิตภัณฑ์หรือบริการของบุคคลที่สาม
                เมื่อคุณใช้ผลิตภัณฑ์หรือบริการเหล่านี้
                อาจถูกรวบรวมข้อมูลเช่นกัน ดังนั้น เราขอแนะนำให้คุณใช้เวลาอ่านนโยบายความเป็นส่วนตัวของบุคคลที่สาม
                อย่างที่อ่านนโยบายของเรา เราไม่รับผิดชอบต่อวิธีการที่บุคคลที่สามใช้ข้อมูลส่วนบุคคลที่พวกเขารวบรวมจากคุณ
                และไม่สามารถควบคุมการใช้งานได้ นโยบายความเป็นส่วนตัวของเราไม่ใช้บังคับแก่เว็บไซต์อื่น ๆ
                ที่เชื่อมโยงผ่านบริการของเรา
                คุณต้องพิจารณาการโต้ตอบระหว่างคุณกับเว็บไซต์ที่เชื่อมโยงด้วยตนเอง
                ก่อนที่คุณจะเข้าสู่หน้าเพจของบุคคลที่สามเป็นครั้งแรก
                ผู้ให้บริการบุคคลที่สามจะแสดงข้อตกลงและประกาศความเป็นส่วนตัวที่เกี่ยวข้องแก่คุณ
                โปรดอ่านข้อตกลงและประกาศความเป็นส่วนตัวเหล่านตี้อย่างละเอียด</p>
            <p><strong>(๓) การถ่ายโอน</strong></p>
            <p>ดรีมมี่จะไม่ถ่ายโอนข้อมูลส่วนบุคคลของคุณให้แก่บริษัท องค์กร หรือบุคคลใด ๆ ยกเว้นกรณีดังต่อไปนี้:</p>
            <p>1. การถ่ายโอนหลังจากได้รับความยินยอมอย่างชัดเจน: หลังจากได้รับความยินยอมจากคุณอย่างชัดเจนแล้ว
                เราจะถ่ายโอนข้อมูลส่วนบุคคลของคุณให้แก่บุคคลอื่น</p>
            <p>2. เมื่อมีการควบกิจการ การเข้าซื้อกิจการ หรือการชำระบัญชีล้มละลาย หากเกี่ยวข้องกับการถ่ายโอนข้อมูลส่วนบุคคล
                เราจะกำหนดให้บริษัทและองค์กรใหม่ที่ถือครองข้อมูลส่วนบุคคลของคุณผูกพันตามนโยบายนี้ต่อไป มิฉะนั้น
                เราจะให้บริษัทและองค์กรนั้นขอความยินยอมจากคุณอีกครั้ง</p>
            <p><strong>(๔) การเปิดเผยต่อสาธารณะ</strong></p>
            <p>เราจะเปิดเผยข้อมูลส่วนบุคคลของคุณต่อสาธารณะในกรณีต่อไปนี้เท่านั้น:</p>
            <p>1. หลังจากได้รับความยินยอมจากคุณอย่างชัดเจน</p>
            <p>2. การเปิดเผยตามกฎหมาย: เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณต่อสาธารณะในกรณีที่ต้องปฏิบัติตามกฎหมาย
                หรือตามกระบวนการทางกฎหมาย การดำเนินคดี หรือความต้องการที่บังคับโดยหน่วยงานกำกับดูแลของรัฐบาล</p>
            <p><strong>๔. วิธีการจัดเก็บและคุ้มครองข้อมูลส่วนบุคคลของคุณ</strong></p>
            <p>
                เราเก็บรักษาข้อมูลส่วนบุคคลตามระยะเวลาที่จำเป็นเพื่อวัตถุประสงค์ในการรวบรวมข้อมูลที่ระบุไว้ในนโยบายความเป็นส่วนตัวนี้
                หรือตามข้อกำหนดทางกฎหมายที่บังคับใช้ หลังจากได้บรรลุวัตถุประสงค์ในการรวบรวม
                หรือหลังจากที่เราได้ยืนยันคำขอลบข้อมูลหรือลบบัญชีของคุณ
                หรือหลังจากที่เรายุติการดำเนินการของผลิตภัณฑ์หรือบริการที่เกี่ยวข้อง เราจะหยุดการเก็บรักษาข้อมูลส่วนบุคคล
                และดำเนินการลบข้อมูลหรือทำข้อมูลให้เป็นนิรนาม ในกรณีที่จะใช้ข้อมูลเพื่อประโยชน์สาธารณะ
                การวิจัยหรือการศึกษาทางวิทยาศาสตร์และทางประวัติศาสตร์ เราจะจัดเก็บข้อมูลที่เกี่ยวข้องต่อไปตามกฎหมายที่บังคับใช้
                แม้ว่าการประมวลผลข้อมูลนั้นอาจไม่เกี่ยวข้องกับวัตถุประสงค์เดิมในการรวบรวมข้อมูล</p>
            <p>สำหรับ Dreamehome รายละเอียดของเวลาการเก็บรักษาข้อมูลส่วนบุคคลของคุณดังต่อไปนี้:</p>
            <p>สำหรับข้อมูลที่จัดเก็บไว้ในแอปพลิเคชัน Dreamehome เมื่อคุณถอดการติดตั้งแอปพลิเคชัน Dreamehome
                หรือลบข้อมูลของแอปพลิเคชัน Dreamehome ออก ข้อมูลทั้งหมดที่จัดเก็บไว้จะถูกลบออกทันที</p>
            <p>สำหรับข้อมูลอุปกรณ์ฮาร์ดแวร์อัจฉริยะและการใช้งาน Dreamehome ที่จัดเก็บไว้ในเซิร์ฟเวอร์
                เมื่อคุณลบอุปกรณ์ฮาร์ดแวร์อัจฉริยะออก ปฏิเสธที่จะยอมรับนโยบายความเป็นส่วนตัวของ Dreamehome และหยุดใช้บริการ
                Dreamehome ข้อมูลทั้งหมดที่จัดเก็บไว้จะถูกลบออกทันที</p>
            <p>สำหรับบันทึกการใช้งาน ข้อมูลสถิติ และข้อมูลประวัติที่จัดเก็บไว้ในเซิร์ฟเวอร์ เราจะลบออกเมื่อล้างข้อมูลเซิร์ฟเวอร์
                โดยปกติแล้ว ข้อมูลจะถูกเก็บรักษาไว้ไม่เกิน 2 ปี</p>
            <p>นอกจากนี้แล้ว เมื่อผลิตภัณฑ์หรือบริการของเราหยุดดำเนินการ เราจะแจ้งให้คุณทราบด้วยข้อความ หนังสือประกาศ
                หรือรูปแบบอื่น ๆ และจะลบข้อมูลส่วนบุคคลของคุณหรือทำข้อมูลให้เป็นนิรนาม ภายในระยะเวลาที่เหมาะสม</p>
            <p><strong>๕. สิทธิของคุณ</strong></p>
            <p><strong>(๑) การเข้าถึง แก้ไข และลบข้อมูลส่วนบุคคลของคุณ</strong></p>
            <p>ตามกฎหมายและระเบียบข้อบังคับของประเทศหรือภูมิภาคที่คุณอาศัยอยู่ คุณมีสิทธิในการยื่นคำขอการเข้าถึง แก้ไข
                และลบข้อมูลส่วนบุคคลใด ๆ ที่เกี่ยวข้องกับคุณที่เราถือครองอยู่ (ต่อไปนี้จะเรียกว่าคำขอ) โปรดส่งข้อความให้เรา
                หรือติดต่อเราผ่าน Dreamehome กฎหมายส่วนใหญ่กำหนดไว้ว่า คำขอจากเจ้าของข้อมูลส่วนบุคคลต้องเป็นไปตามข้อกำหนดพิเศษ
                ซึ่งนโยบายความเป็นส่วนตัวนี้กำหนดไว้ว่า คำขอของคุณต้องเป็นไปตามเงื่อนไขต่อไปนี้:</p>
            <p>ผ่านช่องทางพิเศษสำหรับส่งคำขอของเรา และเพื่อรักษาความปลอดภัยของข้อมูลของคุณ คำขอของคุณต้องทำให้เป็นลายลักษณ์อักษร
                (เว้นแต่กฎหมายท้องถิ่นระบุไว้อย่างชัดเจนว่ายอมรับคำขอปากเปล่า)</p>
            <p>ให้ข้อมูลที่เพียงพอ เพื่อให้เราสามารถยืนยันตัวตนของคุณได้ ตรวจสอบให้แน่ใจว่าผู้ขอเป็นเจ้าของข้อมูล
                หรือผู้ที่ได้รับอนุญาตตามกฎหมาย</p>
            <p>ตราบใดที่เราได้รับข้อมูลที่เพียงพอและยืนยันว่าสามารถดำเนินการตามคำขอของคุณได้
                เราจะตอบกลับคำขอของคุณภายในเวลาที่กำหนดโดยกฎหมายคุ้มครองข้อมูลที่บังคับใช้ ซึ่งมีรายละเอียดดังต่อไปนี้</p>
            <p>ตามคำขอของคุณและข้อกำหนดของกฎหมายที่บังคับใช้
                เราสามารถให้บันทึกข้อมูลส่วนบุคคลของคุณที่เราได้รวบรวมและประมวลผลจำนวน 1 ชุดโดยฟรี หากคุณมีคำเรียกร้องอื่น ๆ
                กับข้อมูลที่เกี่ยวข้อง
                เราอาจเรียกเก็บค่าธรรมเนียมในจำนวนที่เหมาะสมจากคุณตามกฎหมายที่บังคับใช้และต้นทุนการจัดการที่เกิดขึ้นจริง</p>
            <p>ตามกฎหมายและระเบียบข้อบังคับที่บังคับใช้ คุณอาจมีสิทธิในการขอให้เราลบข้อมูลส่วนบุคคลของคุณ
                เราจะประเมินคำขอลบข้อมูลของคุณ หากเป็นไปตามระเบียบที่เกี่ยวข้อง เราจะดำเนินการตามขั้นตอนที่เหมาะสม
                ซึ่งรวมถึงวิธีการทางเทคนิคด้วย หลังจากที่คุณหรือเราช่วยให้คุณลบข้อมูลบางอย่างออกจากบริการของเราแล้ว
                ด้วยข้อจำกัดจากกฎหมายที่บังคับใช้และเทคโนโลยีรักษาความปลอดภัย
                เราอาจไม่สามารถลบข้อมูลที่เกี่ยวข้องออกจากระบบสำรองข้อมูลได้ทันที เราจะจัดเก็บข้อมูลส่วนบุคคลของคุณอย่างปลอดภัย
                และแยกออกจากข้อมูลที่จะประมวลผลต่อไป จนกว่าระบบสำรองข้อมูลได้ลบข้อมูลออกหรือทำข้อมูลให้เป็นนิรนาม เช่น ตาม
                "กฎหมายอีคอมเมิร์ซแห่งสาธารณรัฐประชาชนจีน" ข้อมูลสินค้าและบริการ
                และข้อมูลการซื้อขายของคุณจะต้องถูกเก็บรักษาไว้เป็นเวลาอย่างน้อยสามปี นับจากวันที่ทำธุรกรรมเสร็จสิ้น</p>
            <p>เรามีสิทธิในการปฏิเสธคำขอที่ไม่สำคัญ/ส่งซ้ำไปซ้ำมา คำขอที่สร้างความเสียหายต่อความเป็นส่วนตัวของผู้อื่น
                คำขอที่ไม่สมจริง ขอคำเกี่ยวกับงานด้านเทคนิคที่เหมาะสม คำขอที่ไม่ต้องดำเนินการใด ๆ ตามกฎหมายท้องถิ่น
                คำขอที่เกี่ยวข้องกับข้อมูลที่เปิดเผยต่อสาธารณะ และข้อมูลที่ให้มาตามเงื่อนไขการรักษาความลับ
                หากเราเชื่อว่าคำขอลบข้อมูลหรือเข้าถึงข้อมูล อาจทำให้เราไม่สามารถใช้ข้อมูลอย่างถูกกฎหมาย
                เพื่อวัตถประสงค์ในการต่อต้านการฉ้อโกงและรักษาความปลอดภัยที่กล่าวไว้ข้างต้น เราอาจปฏิเสธเช่นกัน</p>
            <p><strong>(๒) การเพิกถอนความยินยอม</strong></p>
            <p>คุณสามารถส่งคำขอเพิกถอนความยินยอมในการรวบรวม ใช้งาน
                และ/หรือเปิดเผยข้อมูลส่วนบุคคลของคุณที่เราถือครองหรือควบคุมอยู่
                ตามรายละเอียดของบริการที่ได้รับ คุณสามารถติดต่อเราตามวิธีการที่ระบุไว้ในบทที่ ๗ ของนโยบายความเป็นส่วนตัวนี้
                เพื่อดำเนินการต่อไป เราจะดำเนินการตามคำขอของคุณภายในเวลาที่เหมาะสมหลังจากได้รับคำขอจากคุณ และจะไม่รวบรวม ใช้งาน
                และ/หรือเปิดเผยข้อมูลส่วนบุคคลของคุณต่อไป ตามคำขอของคุณ</p>
            <p>โปรดระวัง ตามขอบเขตการประมวลผลข้อมูลที่เราได้รับความยินยอมจากคุณ
                การเพิกถอนความยินยอมอาจทำให้คุณไม่สามารถใช้บริการ
                Dreamehome หรือผลิตภัณฑ์อุปกรณ์อัจฉริยะได้ แต่การเพิกถอนความยินยอมหรือการอนุญาต
                จะไม่ส่งผลกระทบต่อการประมวลผลข้อมูลส่วนบุคคลก่อนหน้านี้ที่ดำเนินการไปตามความยินยอมของคุณ</p>
            <p>คุณสามารถออกจากแผนการปรับปรุงประสบการณ์ผู้ใช้ได้ ด้วยการส่งคำขอเพิกถอนความยินยอม หรือดำเนินการแก้ไขในหน้าเพจ
                Dreamehome เพื่อเพิกถอนความยินยอมในการใช้ข้อมูลส่วนบุคคลรายการนี้</p>
            <p><strong>(๓) การลบบัญชี Dreamehome</strong></p>
            <p>คุณสามารถลบบัญชี Dreamehome ออกโดยไปที่ "ของฉัน" - "การตั้งค่าบัญชี" - "การลบบัญชี" หากคุณต้องการลบบัญชี
                Dreamehome
                โปรดทราบว่า การลบบัญชี Dreamehome จะทำให้คุณไม่สามารถใช้ผลิตภัณฑ์และบริการของ Dreamehome
                และอุปกรณ์ฮาร์ดแวร์อัจฉริยะทั้งหมดได้ โปรดดำเนินการด้วยความระมัดระวัง
                เพื่อคุ้มครองสิทธิที่ถูกต้องตามกฎหมายของคุณหรือผู้อื่น เราจะพิจารณาว่าจะสนับสนุนคำขอลบบัญชีของคุณหรือไม่
                ตามสภาพการใช้ผลิตภัณฑ์และบริการของ Dreame และอุปกรณ์ฮาร์ดแวร์อัจฉริยะต่าง ๆ ของคุณ</p>
            <p><strong>๖. การถ่ายโอนข้อมูลข้ามพรมแดน</strong></p>
            <p>เราให้ผลิตภัณฑ์และบริการผ่านทรัพยากรและเซิร์ฟเวอร์ทั่วโลก ซึ่งหมายความว่า หลังจากได้รับความยินยอมจากคุณมา
                ข้อมูลส่วนบุคคลของคุณอาจถูกถ่ายโอนไปยังเขตอำนาจต่างประเทศที่นอกเหนือประเทศ/ภูมิภาคที่คุณอาศัยอยู่
                หรือได้รับการเข้าถึงจากเขตอำนาจต่างประเทศดังกล่าว
                ข้อมูลของคุณอาจถูกส่งไปยังประเทศ/ภูมิภาคที่มีมาตรการคุ้มครองข้อมูลและกฎหมายอื่น ๆ
                ที่ไม่สมบูรณ์ครบถ้วนเหมือนมาตรการและกฎหมายในประเทศ/ภูมิภาคที่คุณอาศัยอยู่ ในกรณีแบบนี้
                เราจะใช้มาตรการที่เหมาะสมและถูกต้องตามกฎหมายของแต่ละเขตอำนาจ เพื่อให้ข้อมูลส่วนบุคคลของคุณได้รับการคุ้มครองต่อไป
            </p>
            <p>หมายเหตุ:</p>
            <p>หากคุณอาศัยอยู่ในเขตเศรษฐกิจยุโรป (EEA) และข้อมูลส่วนบุคคลของคุณถูกถ่ายโอนไปยังพื้นที่นอก EEA เราจะ:
                ประมวลผลข้อมูลส่วนบุคคลของคุณในพื้นที่ที่คณะกรรมาธิการยุโรปยืนยันว่าสามารถให้การคุ้มครองในระดับที่เพียงพอ
                หรือใช้มาตรการที่เหมาะสมในการคุ้มครองข้อมูลส่วนบุคคลของคุณ ซึ่งรวมถึงการถ่ายโอนข้อมูลตามกลไกการถ่ายโอนที่เหมาะสม
                เช่น ข้อสัญญามาตรฐานของคณะกรรมาธิการยุโรป</p>
            <p><strong>๗. ติดต่อเรา</strong></p>
            <p>หากคุณมีข้อเสนอแนะหรือข้อสงสัยใด ๆ เกี่ยวกับนโยบายความเป็นส่วนตัวนี้ หรือคุณมีข้อสงสัยใด ๆ เกี่ยวกับการรวบรวม
                ใช้งาน หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ โปรดติดต่อเราตามที่อยู่ด้านล่าง หรือไปที่ "ของฉัน" -
                "ติดตามและให้ข้อเสนอแนะ" พร้อมระบุ "นโยบายความเป็นส่วนตัว"
                สำหรับคำร้องขอสิทธิและคำถามขอคำปรึกษาที่เกี่ยวข้องกับข้อมูลส่วนบุคคล
                เรามีทีมงานมืออาชีพคอยช่วยแก้ไขปัญหาที่คุณพบ
                หากปัญหาของคุณเกี่ยวข้องกับเรื่องที่ค่อนข้างสำคัญ เราอาจต้องขอข้อมูลเพิ่มเติมจากคุณ
                หากคุณไม่พอใจกับคำตอบที่ได้รับ
                คุณสามารถยื่นคำร้องเรียนไปยังหน่วยงานกำกับดูแลที่เกี่ยวข้องในเขตอำนาจศาลของพื้นที่ที่คุณอาศัยอยู่
                หากคุณขอคำปรึกษาจากเรา เราจะให้ข้อมูลเกี่ยวกับช่องทางการร้องเรียนที่อาจเหมาะสมแก่คุณ ตามสถานการณ์จริงของคุณ </p>
            <p><strong>ที่อยู่อีเมล:</strong></p>
            <ul>
                <li>ข้อมูลติดต่อในจีน: <a className="page"
                    href="mailto:privacy@dreame.tech">privacy@dreame.tech</a></li>
                <li>ข้อมูลติดต่อ DPO ในสิงคโปร์: <a className="page"
                    href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></li>
                <li>ข้อมูลติดต่อตัวแทนสหภาพยุโรป: <a className="page"
                    href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></li>
            </ul>
            <p><strong>หมายเลขโทรศัพท์: </strong>400-875-9511</p>
            <p><strong>เว็บไซต์: </strong><a className="page"
                href="https://www.dreametech.com">https://www.dreametech.com</a></p>
            <p><strong>๘. วิธีการอัปเดตของนโยบายความเป็นส่วนตัวนี้</strong></p>
            <p>ดรีมมี่ขอสงวนสิทธิ์ในการอัปเตดนโยบายนี้ในเวลาที่เหมาะสม เมื่อนโยบายมีการเปลี่ยนแปลง
                เราจะแสดงนโยบายที่เปลี่ยนแปลงใหม่ผ่านหน้าต่างป๊อปอัปหรือวิธีการอื่น ๆ ที่เห็นได้ชัดเจน
                หลังจากได้รับความยินยอมจากคุณแล้ว เราจึงจะดำเนินการรวบรวม ใช้งาน และจัดเก็บข้อมูลส่วนบุคคลของคุณตามนโยบายใหม่
            </p>
            <p>นโยบายนี้มีผลใช้บังคับตั้งแต่วันที่อัปเดต</p>
            <p>วันที่อัปเดตล่าสุด: 28 สิงหาคม 2564</p>
            <p><strong>ตารางแนบท้ายที่ 1 : รายละเอียดของ SDK บุคคลที่สาม</strong></p>
            <p>* เพื่อให้คุณได้รับบริการพื้นฐานและบริการเพิ่มเติมที่เป็นมืออาชีพและปลอดภัยมากขึ้น Dreamehome จะใช้ผลิตภัณฑ์ SDK
                ของบุคคลที่สาม ขอเปิดเผยผลิตภัณฑ์ SDK ของบุคคลที่สามที่มีอยู่ใน Dreamehome ในปัจจุบันดังต่อไปนี้:</p>
            <div className='tableStyle'>
                <table>
                    <tr>
                        <td>
                            <p>บริการ SDK</p>
                        </td>
                        <td>
                            <p>ฟังก์ชั่น</p>
                        </td>
                        <td>
                            <p>ข้อมูลที่รับ</p>
                        </td>
                        <td>
                            <p>นโยบายความเป็นส่วนตัวของบุคคลที่สาม</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng SDK สำหรับการรวบรวมและวิเคราะห์</p>
                        </td>
                        <td>
                            <p>การรวบรวมและวิเคราะห์</p>
                        </td>
                        <td>
                            <p>หมายเลขประจำเครื่อง (IMEI/Mac/android ID/IDFA/OPENUDID/GUID ข้อมูล IMSI ของซิมการ์ด) ตำแหน่งที่อยู่
                            </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng SDK สำหรับการส่งข้อความ</p>
                        </td>
                        <td>
                            <p>การส่งข้อความ</p>
                        </td>
                        <td>
                            <p>หมายเลขประจำเครื่อง (IMEI/Mac/android ID/IDFA/OPENUDID/GUID ข้อมูล IMSI ของซิมการ์ด) ตำแหน่งที่อยู่
                            </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng SDK สำหรับการแบ่งปันบนโซเชียลมีเดีย</p>
                        </td>
                        <td>
                            <p>การแบ่งปันไปยังบุคคลที่สาม</p>
                        </td>
                        <td>
                            <p>หมายเลขประจำเครื่อง (IMEI/Mac/android ID/IDFA/OPENUDID/GUID ข้อมูล IMSI ของซิมการ์ด) ตำแหน่งที่อยู่
                            </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Agora SDK</p>
                        </td>
                        <td>
                            <p>การแชทด้วยเสียง การเล่นสตรีมมิ่งวิดีโอ</p>
                        </td>
                        <td>
                            <p>ข้อมูลอุปกรณ์ สถานะเครือข่าย กล้อง ไมโครโฟน พื้นที่จัดเก็บข้อมูลการอ่านและการบันทึก</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Huawei SDK สำหรับการส่งข้อมูล</p>
                        </td>
                        <td>
                            <p>การส่งข้อมูล</p>
                        </td>
                        <td>
                            <p>ข้อมูลหมายเลขประจำเครื่อง</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Xiaomi SDK สำหรับการส่งข้อมูล</p>
                        </td>
                        <td>
                            <p>การส่งข้อมูล</p>
                        </td>
                        <td>
                            <p>ข้อมูลหมายเลขประจำเครื่อง รุ่นของอุปกร์ ประเภทเครือข่าย พื้นที่จัดเก็บของอุปกรณ์
                                ข้อมูลกระบวนการทำงานของอุปกรณ์ เวอร์ชั่นของแอปพลิเคชัน เวอร์ชั่น SDK</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>OPPO SDK สำหรับการส่งข้อมูล</p>
                        </td>
                        <td>
                            <p>การส่งข้อมูล</p>
                        </td>
                        <td>
                            <p>ข้อมูลหมายเลขประจำเครื่อง</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>VIVO SDK สำหรับการส่งข้อมูล</p>
                        </td>
                        <td>
                            <p>การส่งข้อมูล</p>
                        </td>
                        <td>
                            <p>ข้อมูลหมายเลขประจำเครื่อง</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>WeChat SDK</p>
                        </td>
                        <td>
                            <p>การเข้าสู่ระบบด้วยบัญชี WeChat การแบ่งปันไปยัง WeChat</p>
                        </td>
                        <td>
                            <p>ข้อมูลหมายเลขประจำเครื่อง ข้อมูลเครือข่าย</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>QQ SDK</p>
                        </td>
                        <td>
                            <p>การแบ่งปัน</p>
                        </td>
                        <td>
                            <p>ข้อมูลหมายเลขประจำเครื่อง ข้อมูลเครือข่าย</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Weibo SDK</p>
                        </td>
                        <td>
                            <p>การเข้าสู่ระบบด้วยบัญชี Weibo การแบ่งปันไปยัง Weibo</p>
                        </td>
                        <td>
                            <p>ข้อมูลหมายเลขประจำเครื่อง ข้อมูลเครือข่าย</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>AppleID SDK</p>
                        </td>
                        <td>
                            <p>เข้าสู่ระบบด้วย Apple ID</p>
                        </td>
                        <td>
                            <p>Apple ID</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.Apple.com/legal/privacy/szh/">https://www.Apple.com/legal/privacy/szh/</a></p>
                        </td>
                    </tr>
                </table>
            </div>
            <div className='height'></div>

        </div>
    )
}

export default PricacyPolicy